module.exports = __webpack_public_path__ + "15f21075c611910d5d032dfaf9041006.png";